export default __webpack_public_path__ + "static/media/call-missed.59162605.svg";